import { render, staticRenderFns } from "./SolicitudRegistroObra.vue?vue&type=template&id=c2eaaae6&scoped=true&"
import script from "./SolicitudRegistroObra.vue?vue&type=script&lang=js&"
export * from "./SolicitudRegistroObra.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudRegistroObra.vue?vue&type=style&index=0&id=c2eaaae6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2eaaae6",
  null
  
)

export default component.exports